import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003606FunctionFinish } from './P0003606/Installation/P0003606InstallationFinish';
import { P0003606FunctionReset } from './P0003606/Installation/P0003606InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003606InjectionPhMiseenOeuvreInit } from './P0003606/InjectionPh/miseenoeuvre/P0003606InjectionPhMiseenOeuvreInit';
import { P0003606InstallationDosageComponent } from './P0003606/Installation/p0003606-installation-dosage/p0003606-installation-dosage.component';
import { P0003606InstallationDetecteurFinBidonComponent } from './P0003606/Installation/p0003606-installation-detecteur-fin-bidon/p0003606-installation-detecteur-fin-bidon.component';
import { P0003606CardInjectionPhControleComponent } from './P0003606/InjectionPh/cards/p0003606-card-injection-ph-controle/p0003606-card-injection-ph-controle.component';
import { P0003606CardInjectionPhStatutComponent } from './P0003606/InjectionPh/cards/p0003606-card-injection-ph-statut/p0003606-card-injection-ph-statut.component';
import { P0003606Alarm } from './P0003606/Alarm/P0003606Alarm';
import { P0003606InjectionPhMiseenOeuvreRegulationComponent } from './P0003606/InjectionPh/miseenoeuvre/p0003606-injection-ph-miseen-oeuvre-regulation/p0003606-injection-ph-miseen-oeuvre-regulation.component';
import { P0003606InjectionPhMiseenOeuvreProtectionComponent } from './P0003606/InjectionPh/miseenoeuvre/p0003606-injection-ph-miseen-oeuvre-protection/p0003606-injection-ph-miseen-oeuvre-protection.component';
import { P0003606InjectionPhControleComponent } from './P0003606/InjectionPh/cps/p0003606-injection-ph-controle/p0003606-injection-ph-controle.component';
import { P0003606InjectionPhParametersComponent } from './P0003606/InjectionPh/cps/p0003606-injection-ph-parameters/p0003606-injection-ph-parameters.component';
import { P0003606InjectionPhStatutComponent } from './P0003606/InjectionPh/cps/p0003606-injection-ph-statut/p0003606-injection-ph-statut.component';

export class P0003606Data {
  iphCCommandeAmorcageCloud: number = 0;

  iphCCommandeAmorcageBle: number = 0;

  iphCCommandeAmorcageIHM: number = 0;

  iphCActivationRegulation: number = 0;

  iphCAckUtilisateur: number = 0;

  iphCResetCompteur: number = 0;

  iphCConfirmationOTA: number = 0;

  iphCResetUsine: number = 0;

  iphPDureeEntreDeuxInjections: number = 0;

  iphPDureeInjection: number = 0;

  iphPConsigneRegulationPh: number = 0;

  iphPDureeLimiteSurdosage: number = 0;

  iphIConfigurationProduit: number = 0;

  iphIActivationFonctionAutoMaintien: number = 0;

  iphIActivationProtectionSurdosage: number = 0;

  iphIDetecteurFinBidonInstalle: number = 0;

  iphISensContactFinBidon: number = 0;

  iphIActivationSecuritePh: number = 0;

  iphISondePhReference: number = 0;

  iphITypeCorrecteurPh: number = 0;

  iphISourceReferenceDebit: number = 0;

  iphSEtatBouton: number = 0;

  iphSAlarme: number = 0;

  iphSEtatPompe: number = 0;

  iphSCommandeInjection: number = 0;

  iphSCommandeAmorcage: number = 0;

  iphSMesurePhReferenceDisponible: number = 0;

  iphSCommandeRegulation: number = 0;

  iphSSecuritePh: number = 0;

  iphSMiseEnRouteFiltration: number = 0;

  iphSArretInjection: number = 0;

  iphSProtectionSurdosage: number = 0;

  iphSEtatContactFinBidon: number = 0;

  iphSFinBidon: number = 0;

  iphSCompteurBouton: number = 0;

  iphSNombreCommutationRelais: number = 0;

  iphSCompteurResetCompteur: number = 0;

  iphSMesurePhReference: number = 0;

  iphSDetectionDebitReference: number = 0;

  iphSDureeDebitMaintenu: number = 0;

  iphSCompteurSurdosageEnSecondes: number = 0;

  iphSNombreTotalProtectionSurdosage: number = 0;

  iphSCompteurResetUsine: number = 0;

  iphSCompteurTempsInjection: number = 0;
}

export class P0003606 extends IProduct {
  override deviceTableIndex: number = 13;

  override modelIdentifier?: string = 'P00036-06';

  override dataIdentifier?: string = 'P0003606';

  override manufacturerName?: string = 'ACWA';

  data: P0003606Data = new P0003606Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003606/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003606/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003606/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003606;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003606?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003606.tuto.installation.help.title',
      helpSlides: [
        'P0003606.tuto.installation.help.1',
        'P0003606.tuto.installation.help.2',
        'P0003606.tuto.installation.help.3',
        'P0003606.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003606/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003606/installation-1_dark.png',
          },
          text: 'P0003606.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003606/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003606/installation-2_dark.png',
          },
          text: 'P0003606.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003606/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003606/installation-1_dark.png',
          },
          text: 'P0003606.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003606/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003606/update-2_dark.png',
          },
          text: 'P0003606.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P0003606InstallationDosageComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P0003606InstallationDetecteurFinBidonComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P0003606FunctionFinish,
        reset: P0003606FunctionReset,
      },

      controlCards: [
        { component: P0003606CardInjectionPhControleComponent, weight: 17 },
      ],

      statusCards: [
        { component: P0003606CardInjectionPhStatutComponent, weight: 15 },
      ],

      alarms: {
        component: P0003606Alarm,
        weight: 17,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.TREATMENTPH];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.INJECTION_PH ||
      functionnality == EventProductFunctionnalityEnum.TREATMENTPH
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P0003606InjectionPhMiseenOeuvreRegulationComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P0003606InjectionPhMiseenOeuvreProtectionComponent,
              condition: () => {
                return true;
              },
            },
          ],
          init: P0003606InjectionPhMiseenOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          component: P0003606InjectionPhControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P0003606InjectionPhParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003606InjectionPhStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P0003606.historique.commandeInjection',
                mode: HistoryGraphModeEnum.DATA,
                property: 'iphSCompteurTempsInjection',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.SECONDE,
                yModeOptions: {
                  min: 0,
                  max: 18 * 60,
                  minMensuel: 0,
                  maxMensuel: 7.5 * 60 * 60,
                  step: 6 * 60,
                  stepMensuel: 30 * 60,
                },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P0003606.historique.commandeInjectionLitre',
                mode: HistoryGraphModeEnum.DATA,
                property: 'iphSCompteurInjectionLitre',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.LITRE,
                yModeOptions: {
                  min: 0,
                  max: 0.5,
                  minMensuel: 0,
                  maxMensuel: 2,
                  step: 0.1,
                  stepMensuel: 0.5,
                },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },

              {
                title: 'P0003606.historique.mesurePh',
                mode: HistoryGraphModeEnum.DATA,
                property: 'iphSMesurePhReference',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.PH_CENTIEME,
                yModeOptions: { min: 200, max: 1200 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.InjectionPh_Controle,
      propertyName: 'iphCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 16;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).iphIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
